<import from="../three-canvas/three-canvas"></import>
<import from="../code-editor/code-editor"></import>
<import from="../preview-buttons/preview-buttons"></import>
<div class="middle_body">
    <code-editor></code-editor>
    <preview-buttons></preview-buttons>
    <three-canvas></three-canvas>
</div>